export default __webpack_public_path__ + "static/mais-tempo-para-o-bem-d2b74c5f4993860ddf66e91eb08ef65a.png";